import { render, staticRenderFns } from "./PaymentDocumentRow.vue?vue&type=template&id=40acd87d"
import script from "./PaymentDocumentRow.vue?vue&type=script&lang=js"
export * from "./PaymentDocumentRow.vue?vue&type=script&lang=js"
import style0 from "./PaymentDocumentRow.vue?vue&type=style&index=0&id=40acd87d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports